module.exports = {
    cacheFiles: [],
    businessLogoCache: [],
    businessDocsCache: [],
    delete_files: '',
};